/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContentType } from './contentType';
import { Updated } from './updated';
import { CmisObjectType } from './cmisObjectType';


export interface EntryType { 
    id?: string;
    title: string;
    summary?: string;
    object?: CmisObjectType;
    updated?: Updated;
    content?: ContentType;
}

